import React from 'react'


class NewInstitution extends React.Component {
    componentWillMount() {
        this.props.onRedirect();
    }

    render() {
        return null
    }
}

export default NewInstitution;



/** WEBPACK FOOTER **
 ** ./src/components/NewInstitution.jsx
 **/